import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import { shallowEqual, useSelector } from 'react-redux';


import AccountsScreen from './Accounts';
import UsersScreen from './Users';
import StatisticsScreen from './Statistics';
import SentScreen from './Sent';
import ARPoolsScreen from './ARPools';
import JournalScreen from './Journal';

export default function Admin() {
  const user = useSelector((state) => state.user, shallowEqual);

  // Verrou global : section /admin réservée aux admins et opérateurs.
  // Aligne avec la visibilité du SideMenu. Chaque Cloud Function appelée
  // depuis ces écrans revérifie le rôle côté serveur (défense en profondeur).
  if (!user || (!user.isAdmin && !user.isOperator)) {
    return <Redirect to="/" />;
  }

  return (
    <Switch>
      {/* Comptes / Utilisateurs / Statistiques : admin uniquement */}
      {user.isAdmin && (
        <Route path="/admin/comptes">
          <AccountsScreen />
        </Route>
      )}
      {user.isAdmin && (
        <Route path="/admin/utilisateurs">
          <UsersScreen />
        </Route>
      )}
      {user.isAdmin && (
        <Route path="/admin/statistiques">
          <StatisticsScreen />
        </Route>
      )}
      {/* Envois papier : admin + opérateur */}
      <Route path="/admin/sent">
        <SentScreen />
      </Route>
      {/* Journal d'audit : admin uniquement (décision 05/10/2026) */}
      {user.isAdmin && (
        <Route path="/admin/journal">
          <JournalScreen />
        </Route>
      )}
      {/* Plages de suivi / liasses AR : admin + opérateur */}
      <Route path="/admin/liasses">
        <ARPoolsScreen />
      </Route>
      {/* Fallback : URL inconnue ou non autorisée → retour à l'accueil */}
      <Route>
        <Redirect to="/" />
      </Route>
    </Switch>
  );
}
